import { CACHE_TIMES } from 'consts';
import { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import api from 'api';
import Block from 'components/ui/Block';
import FAQ from 'components/views/FAQ';
import { AppLayoutProps } from 'types/AppLayoutProps';
import { AnswerGroup } from 'types/FAQ';
import { setCacheHeaders } from 'utils';

type Props = {
  groups: AnswerGroup[];
} & AppLayoutProps;

export const getServerSideProps: GetServerSideProps<Props> = async ctx => {
  const sanity = api().sanity;

  const [navbarMenu, menuBanner, footerMenu, groups] = await Promise.all([
    sanity.navbarMenu(),
    sanity.menuBanner(),
    sanity.footerMenu(),
    sanity.faq(),
  ]);

  setCacheHeaders(ctx.res, CACHE_TIMES.FAQ);

  return {
    props: { footerMenu, groups, menuBanner, navbarMenu },
  };
};

const Page: NextPage<Props> = props => {
  return (
    <>
      <Head>
        <title>Vanliga frågor - Arkivet Second Hand</title>
      </Head>
      <Block padding="big">
        <FAQ groups={props.groups} />
      </Block>
    </>
  );
};

export default Page;
